// @flow
/* eslint-disable react/no-danger */
import React from 'react'
import { withRouter } from 'react-router-dom'
import * as routes from '../constants/routes'
import { parseLocation } from '../util/urls'
import * as ids from '../constants/ids'
import type { FicusDataType } from './frameworks'
import stylesFicus from '../styles'

type Props = {
    fetchingFrameworkInfo: boolean,
    ficusData: FicusDataType,
    location: { pathname: string, search?: string },
    theme: stylesFicus,
    token: { value: string, expires: number },
}

function scrollIntoView(location: { pathname: string, search?: string }) {
    const parsedLoc = parseLocation(location)
    let linkEl
    if (parsedLoc.path.startsWith(routes.INSTRUCTIONS_FRAMEWORK_URL)) {
        linkEl = document.getElementById(ids.INSTR_FRAMEWORK_URL_LINK)
    } else if (parsedLoc.path.startsWith(routes.INSTRUCTIONS_FRAMEWORK)) {
        linkEl = document.getElementById(ids.INSTR_FRAMEWORK_LINK)
    }

    if (linkEl) linkEl.scrollIntoView()
}

/* eslint-disable react/prefer-stateless-function */
class FrameworkInfo extends React.Component<Props> {
    componentDidMount() {
        scrollIntoView(this.props.location)
    }

    componentDidUpdate() {
        scrollIntoView(this.props.location)
    }

    render() {
        const gotoLink = (e) => {
            window.open(this.props.ficusData.frameworkInfoUrl)
            e.stopPropagation()
        }

        if (this.props.fetchingFrameworkInfo) {
            return (
                <span className={this.props.theme.instructions}>
                    <div className={this.props.theme.missingData}>
                        <img
                            alt="Waiting for FICUS data"
                            className={this.props.theme.missingImage}
                            src="/static/er2_ficus/img/dualring.gif"
                        />
                    </div>
                </span>
            )
        }

        return (
            <span className={this.props.theme.instructions}>
                <h3 id={ids.INSTR_FRAMEWORK_LINK}>Framework Documentation</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.ficusData.frameworkInfo }} />

                <h3 id={ids.INSTR_FRAMEWORK_URL_LINK}>Source Link</h3>
                <div style={{ marginBottom: '10px' }}>
                    <a onClick={gotoLink} target="node" role="button" tabIndex={-1} style={{ marginLeft: '10px', fontSize: '12px', cursor: 'pointer' }}>
                        {this.props.ficusData.frameworkInfoUrl}
                    </a>
                </div>
            </span>
        )
    }
}

export default withRouter(FrameworkInfo)
